import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import ScheduleBeneficiaryTransactionDetails from "../../../../containers/Transactions/ScheduleBeneficiaryTransactions/ScheduleBeneficiaryTransactionDetails";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import LargePopupRedirect from "../../../_utils/CommonPopups/CommonLargePopupRedirect";

const dummyFn = () => {};

const ScheduleTransactionDetailsPopup = ({
  closeScheduleTxnDetailModal,
  txn_id,
  detailSelected,
  preApproveAdvice,
  postApproveAdvice,
  preRejectAdvice,
  postRejectAdvice,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(disableSwitcher());
    return () => {
      dispatch(enableSwitcher());
    };
  }, []);

  return (
    <>
      <div onClick={(e) => e.stopPropagation()}>
        <LargePopupRedirect
          headerTitle="Beneficiary schedule details"
          headerFontWeight="semibold"
          headerFontColor="text-primary"
          headertextSize="font-md"
          headersubtext=""
          isfullViewrequired={true}
          fullviewbtnText="Open in full view"
          fullviewbtnType="button"
          fullviewhandleFunction={() => {
            closeScheduleTxnDetailModal();
            navigate(
              `/beneficiary_transaction_dashboard/schedule_view_all/schedule_detail_page/${txn_id}`,
            );
          }}
          fullviewisDisabled={false}
          fullviewenabledTextColor="var(--text-primary)"
          fullviewenabledBgColor="var(--primary-nav)"
          fullviewdisabledBgColor="var(--text-disabled)"
          fullviewhoverOption="white"
          fullviewicon={ICONS?.REDIRECT}
          closeiconbtnType="button"
          closeiconhandleFunction={closeScheduleTxnDetailModal}
          closeiconisDisabled={false}
          closeiconenabledBgColor="var(--primary-nav)"
          closeicondisabledBgColor="var(--text-disabled)"
          closeiconhoverOption="white"
          closeicon={ICONS?.CLOSE}
          isbottomSectionneed={false}
          bottomHeaderTextNeed={false}
        >
          <div className="w-full h-full overflow-y-auto overflow-x-hidden">
            <ScheduleBeneficiaryTransactionDetails
              txn_id={txn_id}
              isPopup={true}
              detailSelected={detailSelected ?? dummyFn}
              preApproveAdvice={preApproveAdvice ?? dummyFn}
              postApproveAdvice={postApproveAdvice ?? dummyFn}
              preRejectAdvice={preRejectAdvice ?? dummyFn}
              postRejectAdvice={postRejectAdvice ?? dummyFn}
            />
          </div>
        </LargePopupRedirect>
      </div>
    </>
  );
};

export default ScheduleTransactionDetailsPopup;
